import React from "react";
import { X } from "lucide-react";

const Cart = ({ isOpen, onClose }) => {
  return (
    <div
      className={`fixed top-0 right-0 h-full w-80 bg-white shadow-xl 
      transform transition-transform duration-300 z-50 
      ${isOpen ? "translate-x-0" : "translate-x-full"}`}
    >
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-xl font-semibold">Your Cart</h2>
        <button onClick={onClose}>
          <X className="w-6 h-6" />
        </button>
      </div>

      {/* No Items */}
      <div className="p-4 text-gray-500 text-center">
        Your cart is empty.
      </div>
    </div>
  );
};

export default Cart;
